/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matches_EmptyInputs */

const cs_matches_empty = /** @type {(inputs: Matches_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné páry.`)
};

const en_matches_empty = /** @type {(inputs: Matches_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching pairs yet.`)
};

/**
* | output |
* | --- |
* | "No matching pairs yet." |
*
* @param {Matches_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const matches_empty = /** @type {((inputs?: Matches_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matches_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_matches_empty(inputs)
	return cs_matches_empty(inputs)
});